import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const passAGrilleConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Pass-a-Grille Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Pass-a-Grille, FL. Sam\'s Tree Service handles dangerous coastal trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_pass_a_grille',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Pass-a-Grille',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Pass-a-Grille Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring professional tree care to the 
     historic and charming properties of <strong>Pass-a-Grille</strong>. At the 
     southern tip of St. Pete Beach, this community sits at the very edge of the 
     Gulf making it one of the most storm exposed locations in Pinellas County. 
     Trees here face direct wind, salt spray, and tidal surge that accelerate decay 
     and create serious hazards for the historic homes and tight lots that define 
     this neighborhood.`,

    `We specialize in <strong>careful, precision tree removal and trimming on 
     historic coastal properties</strong> storm damaged palms and hardwoods, 
     overhanging limbs near closely spaced homes, salt-weakened canopies, and 
     trees requiring expert rigging for safe removal in extremely tight spaces. 
     We respect the character of the neighborhood on every job.`,

    `<strong>Sam's Tree Service</strong> provides dependable, expert tree care 
     throughout <strong>Pass-a-Grille</strong> and the surrounding 
     <strong>St. Pete Beach and South Pinellas</strong> communities protecting 
     your property and preserving what makes this place special.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Pass-a-Grille, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_PassAGrille = () => <LocationPage config={passAGrilleConfig} />;
export default Services_PassAGrille;
